import { Tooltip } from '@nextui-org/react'
import React from 'react'

const TooltipContainer = ({ children, color, content, placement }) => {
  return (
    <Tooltip
    placement={placement || "bottom"}
    content={content || "Tooltip"}
    color={ color || "primary"}
    >
    {children}
    </Tooltip>
  )
}

export default TooltipContainer
